import { groupThousands } from '../token-amount/group';

/**
 * Cents as dollars a person reads: "$1,200.00", "$-1.45". Exact, every
 * cent; null stays null, because an unpriced figure is not $0.00.
 */
export function formatCentsAsDollars(cents: bigint | null): string | null {
  if (cents == null) return null;
  const magnitude = cents < 0n ? -cents : cents;
  const sign = cents < 0n ? '-' : '';
  const fraction = (magnitude % 100n).toString().padStart(2, '0');
  return `$${sign}${groupThousands((magnitude / 100n).toString())}.${fraction}`;
}

/**
 * An exact two decimal USD string ("717.27", "-1.45") as integer cents, so
 * money is added and subtracted without a float. The caller's schema
 * guarantees the shape (`/^-?\d+\.\d{2}$/`, as the investor P&L and fee
 * schemas check every figure).
 */
export function usdCents(value: string): bigint {
  const negative = value.startsWith('-');
  const [whole, fraction] = (negative ? value.slice(1) : value).split('.');
  const cents = BigInt(whole!) * 100n + BigInt(fraction!);
  return negative ? -cents : cents;
}

/**
 * A decimal figure already rounded and grouped for reading ("1,234.5",
 * "1.022804") as dollars, with both cents or none: "$1,234.50",
 * "$1.022804", "$1". The string counterpart of the cents rule in
 * `formatCompactUsd`.
 */
export function formatDecimalDollars(figure: string): string {
  const [whole, fraction] = figure.split('.');
  return fraction == null
    ? `$${figure}`
    : `$${whole}.${fraction.padEnd(2, '0')}`;
}
